import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { TaComunicazioniComponent } from './ta-comunicazioni.component';
import { TaComunicazioniService } from './ta-comunicazioni.service';

import {BrowserModule} from '@angular/platform-browser';

import { TaComunicazioniRoutingModule } from './ta-comunicazioni-routing.module';
import { NbCardModule } from '@nebular/theme';
import { TaComunicazioniComponent } from './ta-comunicazioni.component';
//import { ModalComponent } from 'app/modal-news/modal.component';
@NgModule({
  imports: [
    CommonModule,
    TaComunicazioniRoutingModule,
    FormsModule, 
		ReactiveFormsModule,
    BrowserModule,
    NbCardModule
  ],
  declarations: [TaComunicazioniComponent],
  providers: [TaComunicazioniService],
  exports:[TaComunicazioniComponent]
})
export class TaComunicazioniModule { }
